module.exports = __webpack_public_path__ + "files/b1f4c61a6b16e56e514588a0a1e62772.png";